import { createAction, createReducer } from 'redux-act';

import { TPhoneConfirmationStatuses } from '../interfaces/phoneVerifier';

export type IState = {
  phone: string;
  status: TPhoneConfirmationStatuses;
  loading?: boolean;
};

const initialState: IState = {
  phone: '',
  status: 'required',
  loading: false,
};

export const savePhoneConfirmationInfo = createAction<IState>('phoneConfirmation/saveInfo');
export const setPhoneLoadingStatus = createAction<boolean>('phoneConfirmation/loading');

export default createReducer<IState>({}, initialState)
  .on(savePhoneConfirmationInfo, (state, payload) => ({
    ...state,
    ...payload,
  }))
  .on(setPhoneLoadingStatus, (state, payload) => ({
    ...state,
    loading: payload,
  }));
